



















import { Entity, EntityType, ObjectType } from 'expangine-runtime';
import { EntityOptions } from './EntityTypes';
import { friendlyList } from '@/common';
import TypeEditorBase from '../TypeEditorBase';


export default TypeEditorBase<EntityType, EntityOptions>().extend({
  name: 'EntityEditor',
  computed: {
    title(): string {
      return this.type.options;
    },
    entity(): Entity | null {
      return this.registry.defs.getEntity(this.type.options);
    },
    entityType(): ObjectType | null {
      return this.entity ? this.entity.type : null;
    },
    description(): string {
      return this.entityType
        ? friendlyList(Object.keys(this.entityType.options.props))
        : '';
    },
  },
});
